import { initAllArticleListings } from "./listingRegistry";

// Mount active article listings on current page
initAllArticleListings();
